/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
//import { saveAs } from 'file-saver';
import { Link } from '@mui/material';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import AskDialog from '../../../components/common/dialog/AskDialog';
import * as fileApi from '../../../lib/api/file';
import ProjectTechFileList from '../../../components/techmng/techfiles/ProjectTechFileList';
import { listProjectTechFiles, unloadTechFiles } from '../../../modules/techModule/projectTechFiles';


const ProjectTechFileListContainer = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const { project, files, error, loading } = useSelector(
        ({ techModule, loading }) => ({
            project: techModule.project.project,
            files: techModule.projectTechFiles.files,
            error: techModule.projectTechFiles.error,
            loading: loading['tech/LIST_PROJECT_TECH_FILES'],
        }),
    );

    useEffect(() => {
        if (project) {
            dispatch(listProjectTechFiles('tech_file', project.prjUuid));
        }

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadTechFiles());
        };
    }, [project]);

    const apiRef = useGridApiRef();



    const handleCancelClick = (id) => (event) => {
        event.stopPropagation();
        apiRef.current.startRowEditMode(id, 'view');

        const row = apiRef.current.getRow(id);
        if (row.isNew) {
            apiRef.current.updateRows([{ id, _action: 'delete' }]);
        }
    };

    const [removeId, setRemoveId] = useState(null);
    const handleDeleteClick = (id) => (event) => {
        event.stopPropagation();

        //remove 작업
        setVisible(true);
        setRemoveId(id);
    };

    const onRemove = async () => {
        try {
            const res = await fileApi.removeFile(removeId);
            if (res) {
                apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
                enqueueSnackbar('삭제 성공', {
                    variant: 'success',
                });
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
        setRemoveId(null);
    };

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileUuid',
                headerName: '파일코드',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileTyp',
                headerName: '파일타입',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal1',
                headerName: '프로젝트ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal2',
                headerName: '파일 타입',
                type: 'string',
                minWidth: 120,
                flex: 0.6,
                editable: true,
                filterable: false,
            },
            {
                field: 'fileAttrVal3',
                headerName: '파일참고2',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileNm',
                headerName: '파일명',
                minWidth: 400,
                flex: 1,
                editable: false,
                filterable: false,
                renderCell: (params) => (
                    <Link
                        href={params.row.fileUrl}
                        rel="noopener noreferrer"
                        download
                        target="_blank"
                    >
                        {params.value}
                    </Link>
                ),
            },
            {
                field: 'fileDesc',
                headerName: '비고',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: true,
            },

            {
                field: 'crtNm',
                headerName: '등록자',
                minWidth: 80,
                flex: 1,
                type: 'string',
                editable: false,
            },

            {
                field: 'crtDt',
                headerName: '등록일',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
            },

            {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                width: 100,
                cellClassName: 'actions',
                getActions: ({ id }) => {


                    return [
                        <GridActionsCellItem
                            icon={<DeleteIcon />}
                            label="Delete"
                            onClick={handleDeleteClick(id)}
                            color="inherit"
                        />,
                    ];
                },
            },
        ],
        [apiRef, handleDeleteClick, handleCancelClick],
    );

    const [visible, setVisible] = useState(false);

    const onCancle = () => {
        setVisible(false);
        setRemoveId(null);
    };

    const onConfirm = () => {
        setVisible(false);
        onRemove();
    };

    return (
        <>
            <ProjectTechFileList
                apiRef={apiRef}
                columns={columns}
                files={files}
                error={error}
                loading={loading}
                columnVisibilityModel={{
                    id: false,
                    fileUuid: false,
                    fileTyp: false,
                    fileAttrVal1: false,
                    fileAttrVal3: false,
                  }}
            />
            <AskDialog
                visible={visible}
                title="프로젝트 파일 삭제"
                description="선택한 프로젝트 파일을 삭제하시겠습니까?"
                confirmText="삭제"
                onConfirm={onConfirm}
                onCancle={onCancle}
            />
        </>
    );
};

export default ProjectTechFileListContainer;
